module.exports = __webpack_public_path__ + "static/media/icon-join-the-club.3ae3e096.svg";